<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import {
  getFirestore,
  collection,
  updateDoc,
  serverTimestamp,
  doc,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore/lite'
import CryptoJS from 'crypto-js'

import { firebase } from '@src/firebase-int'

const firestore = getFirestore(firebase)

// import MemberDataService from "../../../../../services/MemberDataService";
// import { tableData } from '../data-advanced';

// import { membersTableData } from '../data-advanced'

export default {
  page: {
    title: 'Cancellation',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage: '',
      successStatus: true,
      processingData: false,
      loading: true,
      noOfMembers: 0,

      pvtData: '',
      secret: '123#$%',
      encData: '',
      processingData: false,

      tableData: [],
      title: 'Cancellation',
      items: [
        {
          text: 'Hibret',
          href: '/',
        },
        {
          text: 'Cancellation',
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: '',
      sortDesc: false,
      fields: [
        { label: 'No.', key: 'index', sortable: false },
        { key: 'name', sortable: true },
        { label: 'Employer', key: 'employerId', sortable: true },
        { key: 'membershipCancellationDate', sortable: true },
        { label: 'Action', key: 'id', sortable: false },
      ],

      dateOptions: { year: 'numeric', month: 'long', day: 'numeric' },
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
  },
  async mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.tableData = await this.readMembers()
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    myRowClickHandler(record, index) {
      console.log(
        index + ' - ' + record.id + ' - ' + record.name + ' - ' + record.dob
      ) // This will be the item data for the row
      this.$router.push({
        name: 'View Application',
        params: { member: record },
      })
    },
    // alert related methods
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },

    async readMembers() {
      let membersData = []
      var memberData
      const membersCol = collection(firestore, 'member')
      const q = query(
        membersCol,
        where('union', '==', this.$store.state.auth.currentUser.adminUnion),
        where('cancelledMembership', '==', true),
        orderBy('membershipCancellationDate', 'desc')
      )
      const membersSnapshot = await getDocs(q)
      membersSnapshot.forEach((doc) => {
        memberData = doc.data()
        //avoid current user from list
        if (
          memberData.contactNumber !=
          this.$store.state.auth.currentUser.contactNumber
        ) {
          if (memberData.dataComplete) {
            memberData.id = doc.id
            memberData.name =
              doc.data().firstName +
              ' ' +
              doc.data().fatherName +
              ' ' +
              doc.data().grandFatherName
            memberData.membershipCancellationDate = doc
              .data()
              .membershipCancellationDate.toDate()
              .toLocaleDateString(undefined, this.dateOptions)
            //memberData.created= doc.data().created.toDate().toLocaleDateString(undefined, this.dateOptions)
            //memberData.updated= doc.data().updated.toDate().toLocaleDateString(undefined, this.dateOptions)
            membersData.push(memberData)
          }
        }
      })
      this.noOfMembers = membersData.length
      this.loading = false
      return membersData
    },


    addMember() {
      this.$router.push({ name: 'Add Member' })
    },

    decryptData(encryptedData) {
      return CryptoJS.AES.decrypt(encryptedData, this.secret).toString(
        CryptoJS.enc.Utf8
      )
    },
    showDetails(memberId) {
      //console.log('>>>>>>>>>>>> Show Details: ' + memberId)
    },

    removeMember(memberId) {
      var index=-1
      for (let i = 0; i < (this.tableData).length; i++) {
        if(this.tableData[i].id==memberId)
        {
          index=i
          break
        }
      }
      
      if (index > -1) {
        this.tableData.splice(index, 1)
      }
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader :title="$t('page.union.titleCancellation')" />
    <div class="row">
      <div class="col-lg-12">
        <b-alert
          v-if="successStatus"
          :show="dismissCountDown"
          dismissible
          fade
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
        <b-alert
          v-else
          :show="dismissCountDown"
          dismissible
          fade
          variant="danger"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="text-muted font-13 mb-4"></p>
            <!--div v-if="(this.$store.state.auth.currentUser.accessLevel=='Union Administrator' || this.$store.state.auth.currentUser.accessLevel=='Administrator')" class="row">
              <div class="col-sm-9">
                
                <b-button variant="primary" @click="addMember"
                  ><i class="uil uil-plus mr-1"></i>Add New</b-button
                >
              </div>
            </div-->

            <div v-if="loading" class="row">
              <div class="col-lg-12 col-sm-12 col-md-12">
                <p class="text-muted font-13 mb-4"></p>
                <p class="text-muted font-13 mb-4">{{ $t('page.allPages.loading') }}</p>
                <b-spinner label="Loading..." variant="primary"></b-spinner>
              </div>
            </div>

            <div v-else class="row">
              <!--div v-if="noOfMembers === 0" class="row"-->
              <div
                v-if="noOfMembers === 0"
                class="col-lg-12 col-sm-12 col-md-12"
              >
                <p class="text-muted font-13 mb-4"></p>
                <p class="text-muted font-13 mb-4">
                  {{ $t('page.union.noCancellations') }}
                </p>
              </div>
              <!--/div-->
              <div v-else class="card-body">
                <div class="row mb-md-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        {{ $t('page.allPages.show') }}&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;{{ $t('page.allPages.entries') }}
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        {{ $t('page.allPages.search') }}:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          :placeholder="$t('page.allPages.searchPlaceHolder')"
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    style="cursor: pointer"
                    :items="tableData"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                  >

                  <template #head(index)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.union.labelIndex')
                      }}</span>
                    </template>
                    <template #head(name)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.union.labelName')
                      }}</span>
                    </template>
                    <template #head(employerId)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.union.labelEmployer')
                      }}</span>
                    </template>
                    <template #head(applicationDate)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.union.labelApplicationDate')
                      }}</span>
                    </template>
                    <template #head(id)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.union.labelAction')
                      }}</span>
                    </template>



                    
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(id)="data">
                      <!--b-button
                        size="sm"
                        @click="acceptApplication(data.value)"
                        class="mr-2 btn-success"
                        :disabled="processingData"
                      >
                        Accept
                      </b-button-->
                      <!--b-button
                        size="sm"
                        @click="rejectApplication(data.value)"
                        class="mr-2 btn-danger"
                        :disabled="processingData"
                      >
                        Reject
                      </b-button-->
                      <b-button
                        size="sm"
                        @click="data.toggleDetails"
                        class="mr-2 btn-info"
                        :disabled="processingData"
                        :class="getSmallButton()"
                      >
                        {{ data.detailsShowing ? $t('page.union.hide') : $t('page.union.show') }} {{
                        $t('page.union.details')
                      }}
                      </b-button>
                    </template>
                    <template #row-details="data">
                      <b-card>
                        <ul>
                          <!--li v-for="(value, key) in data.item" :key="key"
                            >{{ key }}: {{ value }}</li-->
                          <li><b>{{ $t('page.union.id') }}:</b> {{ data.item.id }}</li>
                          <li><b>{{ $t('page.union.phone') }}:</b> {{ data.item.contactNumber }}</li>
                          <li><b>{{ $t('page.union.email') }}:</b> {{ data.item.email }}</li>
                          <li><b>{{ $t('page.union.jobPosition') }}:</b> {{ data.item.position }}</li>
                          <li><b>{{ $t('page.union.gender') }}:</b> {{ data.item.sex }}</li>
                          <li
                            ><b>{{ $t('page.union.address') }}:</b> {{ data.item.region }},
                            {{ data.item.zoneSubcity }}, {{ data.item.woreda }},
                            {{ data.item.kebele }},
                            {{ data.item.houseNumber }}</li
                          >
                        </ul>
                      </b-card>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-right
                      "
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.btn {
  font-size: 1rem;
}
.btnSmallAm {
  font-size: 0.875rem;
}
.btnSmallEn {
  font-size: 0.675rem;
}
.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1rem !important;
}
.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallAm {
  font-weight: 500 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallEn {
  font-weight: 600 !important;
  font-size: 0.675rem !important;
}
</style>
